import { memo } from 'react';

import { type Notification } from '@air/api/types';
import { type NotificationsItemProps } from '@air/component-notifications';

import { NotificationBaseItem } from '~/components/AirNotifications/components/NotificationBaseItem';
import { NotificationShareLinkIcon } from '~/components/AirNotifications/components/NotificationShareLinkIcon';
import { useShortUrlNotificationParentName } from '~/components/AirNotifications/hooks/useShortUrlNotificationParentName';

type NotificationShareLinkNotViewedTypeProps = {
  notification: Notification<'shareLinkNotViewed_userIsShareLinkCreator', 'account'>;
} & Pick<NotificationsItemProps, 'onClick'>;

export const NotificationShareLinkNotViewedType = memo(
  ({ notification, onClick }: NotificationShareLinkNotViewedTypeProps) => {
    const { shortUrl } = notification.data;

    const { shortUrlParentName } = useShortUrlNotificationParentName(shortUrl);

    return (
      <NotificationBaseItem
        meta={shortUrlParentName ? `in ${shortUrlParentName}` : ''}
        onClick={onClick}
        notification={notification}
        prefix={<NotificationShareLinkIcon />}
        title={
          <>
            A link to <b>{shortUrl.objectName}</b> has not been viewed yet
          </>
        }
      />
    );
  },
);

NotificationShareLinkNotViewedType.displayName = 'NotificationShareLinkNotViewedType';
